var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createOverridableComponent } from '../util/OverridableComponent';
import { Button } from './Button';
import { forwardRef } from 'react';
import { Edge, Align } from '../util/getRelativePosition';
import { DropdownIcon } from './icons/DropdownIcon';
import { Popover } from './Popover';
import { DropdownMenu } from './DropdownMenu';
export var DropdownMenuButton = forwardRef(function (_a, ref) {
    var children = _a.children, noIcon = _a.noIcon, props = __rest(_a, ["children", "noIcon"]);
    return (jsx(Button, __assign({}, props, { ref: ref }),
        children,
        !noIcon && jsx(DropdownIcon, { sx: { ml: 1 } })));
});
export var DropdownButton = createOverridableComponent(DropdownMenuButton, function (_a, Toggle) {
    var text = _a.text, children = _a.children, _b = _a.edge, edge = _b === void 0 ? Edge.Bottom : _b, _c = _a.align, align = _c === void 0 ? Align.Start : _c, props = __rest(_a, ["text", "children", "edge", "align"]);
    return (jsx(Popover, { edge: edge, align: align, renderTrigger: function (setOpen, ref, open) {
            return (jsx(Toggle, __assign({ onClick: function (e) {
                    e.stopPropagation();
                    setOpen(function (open) { return !open; });
                } }, props, { ref: ref, "aria-expanded": open }), text));
        } },
        jsx(DropdownMenu, null, children)));
});
//# sourceMappingURL=DropdownButton.js.map